import { render } from "./WinLayoutManager.vue?vue&type=template&id=b4ef3570"
import script from "./WinLayoutManager.vue?vue&type=script&lang=js"
export * from "./WinLayoutManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__